/* Tiloli product story: anchor-nav jump + scroll-spy (highlights the section in view). */
class TiloliStory extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-tlps-jump]')];
    this.secs = [...this.querySelectorAll('[data-tlps-sec]')];
    if (!this.tabs.length) return;

    this.offset = () => {
      const h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tlh-height')) || 64;
      return h + 64; // header + sticky anchor-nav
    };

    this.tabs.forEach((t) => t.addEventListener('click', () => {
      const id = t.getAttribute('data-tlps-jump');
      const el = this.querySelector(`[data-tlps-sec="${id}"]`);
      if (!el) return;
      const top = window.scrollY + el.getBoundingClientRect().top - this.offset();
      window.scrollTo({ top, behavior: 'smooth' });
    }));

    this.spy = () => {
      const probe = this.offset() + 8;
      let cur = this.secs[0];
      for (const s of this.secs) {
        if (s.getBoundingClientRect().top <= probe) cur = s;
      }
      if (!cur) return;
      const id = cur.getAttribute('data-tlps-sec');
      this.tabs.forEach((t) => t.classList.toggle('is-active', t.getAttribute('data-tlps-jump') === id));
    };
    this.spy();
    window.addEventListener('scroll', this.spy, { passive: true });
    window.addEventListener('resize', this.spy);
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.spy);
    window.removeEventListener('resize', this.spy);
  }
}
customElements.define('tiloli-story', TiloliStory);

/* Rappel sticky d'ajout au panier : visible uniquement quand le bouton d'ajout principal
   a défilé AU-DESSUS du viewport (l'utilisateur est passé dessous). Pas au chargement. */
(function () {
  function init() {
    var sticky = document.querySelector('[data-tlbb-sticky]');
    var main = document.querySelector('.tlbb__add');
    if (!sticky || !main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var scrolledPast = e.boundingClientRect.top < 0; // bouton principal au-dessus du viewport
      var show = !e.isIntersecting && scrolledPast;
      sticky.classList.toggle('is-on', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }, { threshold: 0 }).observe(main);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Galerie : hauteur exacte ≤ écran − header − miniatures (desktop). On mesure la vraie bande de
   miniatures (slideshow-controls[thumbnails]) + le header (--tlh-height) et on pose --viewport-offset
   au pixel près (le CSS garde +200px en repli pré-JS). Recalculé au resize + via ResizeObserver.
   Horizon rend UN conteneur par slide → on les traite tous (sinon slides 2+ restent sur le repli
   CSS, plus petit que la 1re). Le zoom plein écran est exclu. */
(function () {
  var mq = window.matchMedia('(min-width: 750px)');
  function fit() {
    var containers = document.querySelectorAll('.product-media-container.constrain-height:not(.dialog-zoomed-gallery *)');
    if (!containers.length) return;
    if (!mq.matches) { // mobile : pas de cap
      containers.forEach(function (c) { c.style.removeProperty('--viewport-offset'); });
      return;
    }
    var thumbs = document.querySelector('.media-gallery--carousel slideshow-controls[thumbnails]')
      || document.querySelector('slideshow-controls[thumbnails]');
    var thumbsH = thumbs ? thumbs.getBoundingClientRect().height : 0;
    var hv = getComputedStyle(document.documentElement).getPropertyValue('--tlh-height');
    var header = parseFloat(hv) || 64;
    var stickyTop = header + 16;   // = --sticky-header-offset (cf. tiloli-product.css)
    var gapBottom = 28;            // espace image↔miniatures + respiration bas
    var offset = Math.round(stickyTop + thumbsH + gapBottom);
    containers.forEach(function (c) {
      c.style.setProperty('--viewport-offset', offset + 'px');
      c.style.setProperty('--constrained-min-height', '0px');
    });
  }
  var raf;
  function schedule() { cancelAnimationFrame(raf); raf = requestAnimationFrame(fit); }
  function arm() {
    fit();
    window.addEventListener('resize', schedule);
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    var thumbs = document.querySelector('slideshow-controls[thumbnails]');
    if (thumbs && 'ResizeObserver' in window) new ResizeObserver(schedule).observe(thumbs);
    // les miniatures arrivent parfois après le 1er paint (images) → quelques relances
    [200, 600, 1500].forEach(function (d) { setTimeout(fit, d); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();
